<template>
  <div class="loader-wrapper">
    <ClipLoader :color="'#FF3811'"/>
    <slot></slot>
  </div>
</template>

<script>
import ClipLoader from 'vue-spinner/src/ClipLoader';

export default {
  name: 'Loader',
  components: {
    ClipLoader,
  },
};
</script>

<style lang="sass">
.loader-wrapper
  height: 250px;
  display: flex;
  flex-direction: column
  align-items: center;
  justify-content: center;
</style>



// WEBPACK FOOTER //
// Loader.vue?3513c73d